import React from 'react';
import { icon } from '../Icons'

export default function Postagem(props) {

    return (
        <div className="form-group col-sm-12"> 
            <div className="d-flex">
                <span className="mt-1">{ "Postagem_" + (props.indice + 1) + ": " }</span>
                <input 
                    key={"idFormDenunciaVideo_" + props.indice}
                    name="denunciaVideo"
                    type="text" 
                    className="form-control ml-2" 
                    placeholder="Cole aqui o link do vídeo postado no youtube, facebook, instagran, etc ..." 
                    value={ props.link.link }
                    onChange={ event => props.atualizarLink('link',event.target.value,props.indice) }
                />
                <button 
                    id={"idFormDenunciaLinkVideoTrash_" + props.indice}
                    key={"keyFormDenunciaVideoTrash_" + props.indice}
                    className="btn btn-default"
                    onClick={ () => props.removerLink(props.indice) }
                    type="button"
                >
                    <icon.FaRegTrashAlt 
                        id={"idFormDenunciaVideoTrash_" + props.indice + "_i"} 
                        className="text-danger"
                        aria-hidden="true"
                    />
                </button>
            </div>
        </div>
    );
}